const formatFullDateIfUTC = (inputDateString) => {
  const utcTime = new Date(
    new Date(inputDateString).getTime() -
      (new Date(inputDateString).getTimezoneOffset() - 0) * 60000
  );

  return utcTime;
};

export default formatFullDateIfUTC;
